import React, {useEffect, useState} from "react";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import {withSnackbar} from "notistack";
import {withStyles} from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Grid} from "@material-ui/core";
import Input from "@material-ui/core/Input/Input";
import {
    validateEmail,
    getErrorMessageFromResponse
} from "../../../common/helper";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import {green} from "@material-ui/core/colors";

const styles = (theme) => ({
    disabled: {}, //required for the rule below to work
    root: {
        '&$disabled': {
            color: theme.disabledField.colour
        },
        '&:hover': {
            backgroundColor: 'transparent',
        }
    },
    customLabel:{
        color: theme.fieldLabel.colour,
        position: 'relative',
        marginTop: '0px'
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    rootRadio: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    iconRadio: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIconRadio: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },

});


function AddSubfolderUserDialog(props) {

    //TODO Check if folder Group exists if not, then prompt to create it....or create it and then add the user

    const debug = window.location.pathname.toLowerCase().includes("debug");
    //debug && console.log ('AddSubfolderUserDialog props = ', props);

    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [password, setPassword] = useState("");
    const [success, setSuccess] = useState(false);
    const [existingUser, setExistingUser] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const actionConfig = props.actionConfig;
    const [groups, setGroups] = useState((actionConfig && actionConfig.groups ? actionConfig.groups : []))
    const groupStr = groups.length === 1 ? 'group' : 'groups';

    useEffect(() => {

        debug && console.log ('AddSubfolderUserDialog props = ', props);

        const folderGroupName = (props.groupName)

        //Add folder group to the list of groups
        setGroups(groups => [...groups, folderGroupName]);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.folderDetails, actionConfig, props.userDetails, props.triggerRefreshAuthToken])


    function handleCloseDialog() {
        props.handleCloseDialog();
    }

    const allFieldsComplete = email && firstName && lastName ;

    function validate() {

        let isValid = false;
        //check all fields complete and email format is valid

        if (allFieldsComplete) {
            if (validateEmail(email)) {
                isValid = true
            } else {
                props.enqueueSnackbar("Please enter a valid email address" , {variant: 'error'});
            }
        } else {
            props.enqueueSnackbar("Please complete all fields before submitting" , {variant: 'error'});
        }
        return isValid
    }

    function copyToClipboard() {
        window.navigator.clipboard.writeText(password).then(result=>{
            props.enqueueSnackbar("User password copied to clipboard", {variant: 'success'})
        })
    }

    function Summary() {

        debug && console.log ('Summary: firstName=', firstName, 'lastName=', lastName, 'email=', email, 'groups=', groups)
        return (
            <List>

                <React.Fragment key={"frag"}>
                    <ListItem key={"li" + lastName} >
                        <ListItemAvatar><Avatar style={{backgroundColor: green[500]}}><i className='material-icons'>done</i></Avatar></ListItemAvatar>
                        {
                            password ?
                                <ListItemText key={"liText" + firstName}
                                              primary={firstName + " " + lastName + " (" + email + ") successfully added"}
                                /> :
                                <ListItemText key={"liText" + firstName}
                                              primary={email + " - existing user successfully added to " + groupStr}
                                />
                        }

                    </ListItem>
                </React.Fragment>
            </List>

        )
    }

    function handleSubmitClick() {
        if (validate()) {
            submit()
        }
    }

    async function addUserToGroups() {

        setIsProcessing(true)

        const url = window.REACT_APP_SECURITY_API_BASE_URL + '/okta/groups/addUser';
        const body = {
            "login": email,
            "groups": groups,
            "requiresBoxGroups":  (props.actionConfig.requiresBoxGroups === undefined || props.actionConfig.requiresBoxGroups === true) //note, default is true
        }

        const request = {
            method: 'POST',
            headers: {
                "Authorization": "Bearer " + props.userDetails.accessToken,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body)
        }

        debug && console.log('addUserToGroups url=', url, 'BODY', body, 'request=', request);

        await props.triggerRefreshAuthToken();

        await fetch(url, request)
            .then(response => {
                debug && console.log('addUserToGroups response=', response);
                if (response.ok) {
                    return(response.json())
                } else {
                    Promise.resolve(getErrorMessageFromResponse(response, 'adding user'))
                        .then(message => {
                            props.enqueueSnackbar(message, {variant: 'error'});
                        })
                    debug && console.log("add user to groups error.  url:", url, "request: ", request);
                    return null
                }
            })
            .then(data => {
                debug && console.log('addUserToGroups response.json = ', data)

                if (data) {
                    setSuccess(true)
                    props.enqueueSnackbar("User added to groups successfully" , {variant: 'success'});
                    //refresh list of  group members displayed on folder details screen
                    props.remountFolderGroupMembersDisplay();
                }

                setIsProcessing(false)

            })
            .catch(e => {
                props.enqueueSnackbar("Error adding user to groups (exception: " + e.message + ")" , {variant: 'error'});
                debug && console.log("addUserToGroups  exception:" , e);
                setIsProcessing(false)
            })
    }

    async function submit() {

        setIsProcessing(true)

        const url = window.REACT_APP_SECURITY_API_BASE_URL + window.REACT_APP_SECURITY_API_USER_ENDPOINT;
        const body = {
            "username": email,
            "email": email,
            "firstName": firstName,
            "lastName": lastName,
            "groups": groups,
            "requiresBoxGroups":  (props.actionConfig.requiresBoxGroups === undefined || props.actionConfig.requiresBoxGroups === true) //note, default is true
        }

        const request = {
            method: 'POST',
            headers: {
                "Authorization": "Bearer " + props.userDetails.accessToken,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body)
        }

        debug && console.log('addUser url=', url, 'BODY', body, 'request=', request);

        let existing = false;

        await props.triggerRefreshAuthToken();

        await fetch(url, request)
            .then(response => {
                debug && console.log('addUser response=', response);
                if (response.ok) {
                    return(response.json())
                } else {
                    if (response.status === 400 ) {

                        props.enqueueSnackbar("User already exists, adding user to appropriate " + groupStr + "...", {variant: 'info'});
                        existing = true;
                        return null

                    } else {
                        Promise.resolve(getErrorMessageFromResponse(response, 'adding user'))
                            .then(message => {
                                props.enqueueSnackbar(message, {variant: 'error'});
                            })
                        debug && console.log("add user error.  url:", url, "request: ", request);
                        return null
                    }
                }
            })
            .then(data => {
                debug && console.log('addUser response.json = ', data)

                if (data) {
                    setPassword(data.password)
                    setSuccess(true)
                    props.enqueueSnackbar("User added successfully" , {variant: 'success'});
                    //refresh list of  group members displayed on folder details screen
                    props.remountFolderGroupMembersDisplay();
                }

                if (!existing) {
                    setIsProcessing(false)
                }

            })
            .catch(e => {
                props.enqueueSnackbar("Error adding user (exception: " + e.message + ")" , {variant: 'error'});
                debug && console.log("addUser  exception:" , e);
                setIsProcessing(false)
            })

        if (existing) {
            setExistingUser(true)
            await addUserToGroups()
        }
    }

    const {classes} = props;

    const mailToSubject = 'Access to ' + window.REACT_APP_APP_TITLE
    const mailToBodyNewUser = 'Dear ' + firstName + ',%0A%0A' +
        'You have been granted access to ' + props.folderDetails.name + ' drawings in the ' + window.REACT_APP_APP_TITLE + '.%0A%0AYour temporary password is ' + encodeURIComponent(password) + '%0A%0A' +
        'Please use the following URL to access:%0A%0A' + window.location.origin  +
        '%0A%0ARegards,%0A' + props.userDetails.userName
    const mailToBodyExistingUser = 'Dear ' + firstName + ',%0A%0A' +
        'You have access to ' + props.folderDetails.name + ' drawings in the ' + window.REACT_APP_APP_TITLE + '.%0A%0A' +
        'Please use the following URL to access:%0A%0A' + window.location.origin  +
        '%0A%0ARegards,%0A' +
        props.userDetails.userName
    const mailTo = 'mailto:'+ email + '?subject=' + encodeURIComponent(mailToSubject) + '&body=' + ( existingUser ? mailToBodyExistingUser : mailToBodyNewUser)

    return (
        <div>
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth= {"sm"}
                keepMounted={false}
            >
                <DialogTitle>Add User</DialogTitle>
                <DialogContent>

                    <Grid container spacing={2}>

                        {
                            !success ?

                                <React.Fragment>
                                    <Grid item  xs={12}>
                                        <FormControl fullWidth >
                                            <InputLabel shrink htmlFor="email" required className={classes.customLabel}>Email</InputLabel>
                                            <Input id="email"
                                                   name="email"
                                                   value={email}
                                                   placeholder="Enter user email"
                                                   type="text"
                                                   margin="none"
                                                   variant="outlined"
                                                   autoComplete=""
                                                   onChange={e => setEmail(e.target.value)}
                                                   autoFocus = {true}
                                                   disabled={isProcessing || success}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid item  xs={6}>
                                        <FormControl fullWidth>
                                            <InputLabel shrink htmlFor="firstName" required className={classes.customLabel}>First Name</InputLabel>
                                            <Input
                                                id="firstName"
                                                name="firstName"
                                                value={firstName}
                                                placeholder="Enter first name"
                                                type="text"
                                                margin="none"
                                                variant="outlined"
                                                autoComplete=""
                                                onChange={e => setFirstName(e.target.value)}
                                                autoFocus = {false}
                                                disabled={isProcessing || success}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item  xs={6}>
                                        <FormControl fullWidth>
                                            <InputLabel shrink htmlFor="inputComment" required className={classes.customLabel}>Last Name</InputLabel>
                                            <Input
                                                id="lastName"
                                                name="lastName"
                                                value={lastName}
                                                placeholder="Enter last name"
                                                type="text"
                                                margin="none"
                                                variant="outlined"
                                                autoComplete=""
                                                onChange={e => setLastName(e.target.value)}
                                                autoFocus = {false}
                                                disabled={isProcessing || success}
                                            />
                                        </FormControl>
                                    </Grid>

                                </React.Fragment> :

                                <React.Fragment>

                                    <Grid item  xs={12}>

                                        <Summary/>

                                        {
                                            password &&

                                            <React.Fragment>
                                                <DialogContentText>Please copy the password and share it with the user, they will need to reset it on first use.<br/></DialogContentText>

                                                <FormControl fullWidth>
                                                    <InputLabel shrink htmlFor="password" className={classes.customLabel}>Initial Password</InputLabel>
                                                    <Input
                                                        id="password" name="password" value={password}
                                                        type="text" margin="none" variant="outlined"
                                                        readOnly={true} style={{width: "100%"}}
                                                        onFocus={event => {
                                                            event.target.select()
                                                        }}
                                                    />
                                                </FormControl>

                                            </React.Fragment>
                                        }

                                    </Grid>

                                </React.Fragment>
                        }
                    </Grid>

                </DialogContent>

                <DialogActions>


                    {
                        !isProcessing &&
                        <Button onClick={() => handleCloseDialog()} variant="contained" >
                            { success ? "Close"  : "Cancel"}
                        </Button>
                    }
                    {
                        !success &&
                            <Button onClick={() => handleSubmitClick()} variant={"contained"} color="secondary" disabled={!allFieldsComplete}>
                                {isProcessing ? "Processing..." : "Submit"}
                            </Button>
                    }
                    {
                        success && password &&
                        <Button onClick={() => copyToClipboard()} color="secondary" variant={"contained"}>Copy password</Button>

                    }

                    {
                        success &&
                            <React.Fragment>
                                <Button button component="a" href={mailTo} color="secondary" variant={"contained"}>Email user</Button>
                            </React.Fragment>
                    }

                </DialogActions>

                {
                    isProcessing &&
                    <LinearProgress variant={"indeterminate"} color={"primary"}/>
                }
            </Dialog>
        </div>
    );
}

AddSubfolderUserDialog.propTypes = {
    actionConfig: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    handleCloseDialog: PropTypes.func.isRequired,
    triggerRefreshAuthToken: PropTypes.func.isRequired,
    userDetails: PropTypes.object.isRequired,
    folderDetails: PropTypes.object.isRequired,
    remountFolderGroupMembersDisplay: PropTypes.func.isRequired,
    groupName: PropTypes.string.isRequired
};


export default withSnackbar(withStyles(styles, { withTheme: true })(AddSubfolderUserDialog));